import { DialogPanel } from '@/features/dialogs/common/components/DialogPanel'
import { DialogPanelTitle } from '@/features/dialogs/common/components/DialogPanelTitle'
import { TokenWithValue } from '@/domain/common/types'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { TransactionOverviewDetailsItem } from '@/features/dialogs/common/components/transaction-overview/TransactionOverviewDetailsItem'
import { MyWalletProps } from '@/features/isolated-details/components/my-wallet/MyWallet'

export interface LendWithdrawOverviewPanelProps {
  withdrawAsset: TokenWithValue
  walletOverview: MyWalletProps
}

export function LendWithdrawOverviewPanel({ withdrawAsset, walletOverview }: LendWithdrawOverviewPanelProps) {
  return (
    <DialogPanel>
      <DialogPanelTitle>Transaction overview</DialogPanelTitle>
      <TransactionOverviewDetailsItem label="Withdrawal Capacity in Pool">
        <span>
          {withdrawAsset.token.format(NormalizedUnitNumber(walletOverview.borrow?.poolAvailable || 0), {
            style: 'compact',
          })}{' '}
          {withdrawAsset.token.symbol}
        </span>
      </TransactionOverviewDetailsItem>
    </DialogPanel>
  )
}
